import React, { useEffect, useState } from "react";
import { Link, useParams, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Breadcrumb, Table, Input, Select, Space, Spin } from "antd";
import ButtonField from "../../common/htmlComponents/ButtonField";
import { Collapse } from "antd";
import ExelDownload from "../../image/exeldownload.svg";
import { getRequest, patchRequest, postRequest } from "../../axios";
import {
  ErrorNotificationMsg,
  SuccessNotificationMsg,
} from "../../utils/Notifications";
import { authUserData } from "../../utils/Helper";
import InputField from "../../common/htmlComponents/InputField";
import logo from "../../image/smartbuyer-logo.svg";
const { Option } = Select;

const handleChange = (value) => {};

const { Panel } = Collapse;

const PRApprovalButton = () => {
  const { t } = useTranslation();
  const { id } = useParams();
  const navigate = useNavigate();
  const [btnLoading, setBtnLoading] = useState(false);
  const { resetToken } = useParams();
  const CompanyID = authUserData()?.company ? authUserData()?.company : null;
  const [showRejectReason, setShowRejectReason] = useState("");
  const [PRApprovalButton, setPRApprovalButton] = useState([]);
  const [loading, setLoading] = useState(false);
  const [pdfId, setPdfId] = useState(null);
  const initialState = {
    pr_reject_reason: "",
  };
  const [state, setState] = useState(initialState);

  useEffect(() => {
    const getPRApprovalButton = async () => {
      setLoading(true);

      try {
        let apiResponse = await getRequest(
          `purchase-requisition/?pr_number=${id}`
        );

        if (apiResponse.data.results.data) {
          setPRApprovalButton(apiResponse.data.results.data[0]);
          setPdfId(apiResponse?.data?.results?.data[0]?.id);
          // settotalCount(apiResponse.data.count);
        } else {
          ErrorNotificationMsg(t("error_in_purchase_requisition"));
        }
        setLoading(false);
      } catch (error) {
        setLoading(false);
      }
    };
    getPRApprovalButton();
  }, []);

  const data = [];
  for (let i = 0; i < 3; ++i) {
    data.push({
      key: i.toString(),
      name: "Screen",
      platform: "iOS",
      version: "10.3.4.5654",
      upgradeNum: 500,
      creator: "Jack",
      createdAt: "2014-12-24 23:12:00",
    });
  }
  // const handleRejectWithReason = (value) => {
  //   setShowRejectReason(true); // Show the input field when "Reject With Reason" button is clicked
  //   setRejectReason(value);
  // };
  const handleRejectWithReason = (e) => {
    let { name, value } = e.target;
    setState({ ...state, [name]: value ? value : null });
    setShowRejectReason(e.target.value);
  };

  console.log("pdfId ", pdfId);

  const renderTables = () => {
    if (!PRApprovalButton.purchase_requisition_details) return null;

    // Group purchase_requisition_details by sub_category
    const groupedDetails = {};
    PRApprovalButton.purchase_requisition_details.forEach((detail) => {
      const subCategory = detail.sub_category;
      if (!groupedDetails[subCategory]) {
        groupedDetails[subCategory] = { sites: {}, details: [] };
      }
      groupedDetails[subCategory].details.push(detail);
      detail.site_wise.forEach((site) => {
        groupedDetails[subCategory].sites[site.site_name] = true;
      });
    });

    return Object.entries(groupedDetails).map(
      ([subCategory, { sites, details }], index) => {
        const siteNames = Object.keys(sites);
        const site_wise = Object.keys(sites);
        // const defaultUOMName = "Unit Of Measurement";
        // const defaultTotalQuantity = "Total Quantity";
        const data = [];
        // for (let i = 0; i < 3; ++i) {
        //   data.push({
        //     key: i.toString(),
        //     date: '2014-12-24 23:12:00',
        //     name: 'This is production name',
        //     upgradeNum: 'Upgraded: 56',
        //   });
        // }
        details.map((detail) =>
          data.push({
            ...detail,
            key: detail.pr_details_id.toString(),
            totalQuantity: `${detail.total_quantity} ${detail.unit_of_measurement_name}`,
          })
        );

        const siteNameColumns = siteNames.map((site, index) => ({
          title: site,
          dataIndex: index,
          key: index,
          width: 170,
        }));

        const siteWiseColumns = site_wise.map((site, siteIndex) => ({
          title: "Site Input",
          dataIndex: `siteInput_${siteIndex}`,
          key: `siteInput_${siteIndex}`,
          render: (text, record) => {
            const matchingSite = record.site_wise.find(
              (s) => s.site_name === site
            );
            if (matchingSite) {
              return (
                <Input
                  readOnly
                  key={siteIndex}
                  style={{ width: "100%" }}
                  value={matchingSite.quantity}
                />
              );
            }
            return null; // If no matching site found, render nothing
          },
          width: 170,
        }));

        const columns1 = [
          {
            title: `${index + 1}`,
            dataIndex: "A",
            key: "1",
            width: 50,
          },
          {
            title: `${subCategory}`,
            dataIndex: `${subCategory}`,
            key: `${subCategory}`,
            // width: 170,
          },
          ...siteNameColumns,
          {
            title: "UOM.",
            dataIndex: "UOM",
            key: "7",
            width: 160,
          },
          {
            title: "TOTAL QTY.",
            dataIndex: "TOTAL",
            key: "8",
            width: 150,
          },
        ];

        const thead = <Table columns={columns1} />;

        return (
          // <Panel key={index.toString()} header={`${subCategory}  ${siteNames.join(' ')}  ${defaultUOMName}  ${defaultTotalQuantity}`}>
          <Panel key={index.toString()} header={thead}>
            <Table
              columns={[
                // ...columns,
                {
                  title: `${index + 1}`,
                  dataIndex: "A",
                  key: "1",
                  width: 50,
                  render: (text, record, index) => index + 1,
                },
                {
                  title: "Type Name",
                  dataIndex: "material_type_name",
                  key: "material_type_name",
                  // width: 170,
                },
                ...siteWiseColumns,
                {
                  title: "UOM",
                  dataIndex: "unit_of_measurement",
                  key: "unit_of_measurement",
                  render: (text, record) => (
                    <Select
                      disabled
                      style={{ width: "100%" }}
                      defaultValue={record.unit_of_measurement_name}
                    >
                      <Option
                        key={record.id}
                        value={record.unit_of_measurement_name}
                      >
                        {record.unit_of_measurement_name}
                      </Option>
                    </Select>
                  ),
                  width: 140,
                },
                {
                  title: "Total Quantity",
                  dataIndex: "totalQuantity",
                  key: "totalQuantity",
                  width: 100,
                  render: (text, record) => (
                    <Input
                      key={record.id}
                      style={{ width: "150px" }}
                      value={record.total_quantity}
                    />
                  ),
                },
              ]}
              dataSource={data}
              pagination={false}
            />
          </Panel>
        );
      }
    );
  };
  //   const handleSubmit = async () => {
  //     try {
  //         setBtnLoading(true);
  //         await postRequest("purchase-requisition/pr-approval/" + resetToken + "/" + id).then(
  //             (response) => {
  //                 SuccessNotificationMsg("PR Approval Successfully");
  //                 // setTimeout(handleNavigate, 2000);
  //                 //setTimeout(handleNavigate, 4000);
  //             }
  //         );
  //         setBtnLoading(false);
  //         navigate("/request-for-quotation/assign-rfq")
  //     } catch (error) {
  //         setBtnLoading(false);
  //     }
  // };
  const handleSubmit = async () => {
    try {
      //setBtnLoading(true);
      const payload = {
        pr_status: "Approve",
      };
      let response;
      //if (id !== null) {
      response = await postRequest(
        "purchase-requisition/pr-approval/" + resetToken + "/" + id + "/",
        payload
      );
      //}

      if (response.data.success) {
        //setAddedCompanyId(response.data.data.id);
        // SuccessNotificationMsg(response.data.message);
      }
      // navigate("/request-for-quotation/assign-rfq")
      navigate("/purchase-requisition-assign/1");
    } catch (error) {
      // setBtnLoading(false);
    }
  };

  const handleSubmitRejectReason = async () => {
    const payload = {
      pr_reject_reason: state.pr_reject_reason,
      pr_status: "Reject",
    };
    try {
      // Call your API to submit the reject reason
      const response = await postRequest(
        "purchase-requisition/pr-approval/" + resetToken + "/" + id + "/",
        payload
      );
      // Handle successful response
      // Optionally, you can reset the reject reason input field and hide it
      //setRejectReason("");
      setShowRejectReason(true);
      if (response.data.success) {
        //setAddedCompanyId(response.data.data.id);
        SuccessNotificationMsg("PR Rejected Successfully");
      }
      navigate("/purchase-requisition/archive");
    } catch (error) {
      // Handle error
      console.error("Error submitting reject reason:", error);
      // Optionally, you can display an error message to the user
    }
  };
  const getAllPanelKeys = () => {
    const keys = [];
    // Assuming renderTables() returns an array of panels or null
    const panels = renderTables();
    if (Array.isArray(panels)) {
      panels.forEach((panel, index) => {
        keys.push(index.toString()); // Assuming each panel has a unique key
      });
    }
    return keys;
  };

  const handleDownloadPDF = async () => {
    const endpoint = `purchase-requisition/${pdfId}/download-pr-history-pdf/`;
    try {
      const response = await getRequest(endpoint, { responseType: "blob" }); // Specify responseType as 'blob' to handle binary data (PDF)
      const blob = new Blob([response.data], {
        type: "application/pdf", // Set MIME type to application/pdf for PDF file
      });
      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = `purchase_requisition_${id}-${+new Date()}.pdf`; // Set file extension to .pdf
      link.click();
    } catch (error) {
      ErrorNotificationMsg("Error downloading PR");
    }
  };

  const handleExcelDownload = async () => {
    // const endpoint = `purchase-requisition/${CompanyID}/download-company-pr-history-excel/`;
    const endpoint = `purchase-requisition/${pdfId}/download-single-pr-history-excel/`;
    const fileType = "csv";
    try {
      //setBtnloading(true);
      await getRequest(endpoint)
        .then((response) => {
          const blob = new Blob([response.data], {
            type: "text/csv",
          });
          const link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          //link.download = `purchase_requisition_${id}-${+new Date()}.${fileType}`;
          link.download = `purchase_requisition_${CompanyID}-${+new Date()}.${fileType}`;
          link.click();
          //setBtnloading(false);
        })
        .catch((error) => {
          ErrorNotificationMsg(t(`err_${fileType}_download`));
        });
    } catch (error) {
      //setBtnloading(false);
      ErrorNotificationMsg(error);
    }
  };

  return (
    <>
      <div className="PR-container">
        <Spin spinning={loading}>
          <div className="wrapper fadeInDown fulllHlogo">
            <img
              src={logo}
              width={"200px"}
              height={"36px"}
              alt="Smart Buyer Logo"
            ></img>
          </div>

          <div className="ListingTopBar">
            <div className="pagenamewrap">
              <div className="pagename">
                <h3> PR Approval </h3>

                <Breadcrumb className="Breadcrumb-Sec">
                  <Breadcrumb.Item>
                    <Link to="/dashboard">{t("home")}</Link>
                  </Breadcrumb.Item>
                  <Breadcrumb.Item>PR Approval</Breadcrumb.Item>
                </Breadcrumb>
              </div>
            </div>
          </div>
          <section className="grid-sec mt-5">
            <div className="PR-body">
              <div className="filterrow">
                <div className="filtercol">
                  <Space wrap>
                    <div className="lblwrp">
                      <label>PR Number</label>
                      <h6> {PRApprovalButton.pr_number}</h6>
                    </div>
                    <div className="lblwrp">
                      <label>PR Creator</label>
                      <h6>{PRApprovalButton.pr_creator}</h6>
                    </div>
                    <div className="lblwrp">
                      <label>PR Created Date</label>
                      <h6>{PRApprovalButton.pr_created_date}</h6>
                    </div>
                  </Space>
                </div>
                <div className="btnscol">
                  <Space>
                    <ButtonField
                      className="SaveGradiantBtn"
                      type="primary"
                      htmlType="Excel"
                      label="Excel"
                      onClick={handleExcelDownload}
                      icon={<img src={ExelDownload} alt="Plus Square" />}
                    />
                    <ButtonField
                      className="SaveGradiantBtn"
                      type="primary"
                      htmlType="PDF"
                      label="PDF"
                      onClick={handleDownloadPDF}
                      icon={<img src={ExelDownload} alt="Plus Square" />}
                    />
                  </Space>
                </div>
              </div>

              <div className="PR-body pl-0 pr-0 pt-0">
                {/* <Collapse defaultActiveKey={[]}>{renderTables()}</Collapse> */}
                <Collapse activeKey={getAllPanelKeys()}>
                  {renderTables()}
                </Collapse>
              </div>

              <div className="btnwrp btnfooter">
                <div className="approvereject">
                  {/* {showRejectReason && ( */}
                  <InputField
                    name="pr_reject_reason"
                    label="Reason For Rejection"
                    rules="Please Enter Reject Reason"
                    placeholder="Enter Reject Reason"
                    //handleInputChange={handleRejectWithReason}
                    handleInputChange={handleRejectWithReason}
                    // value={}
                  />
                  {/* )} */}
                </div>
                <div>
                  <ButtonField
                    className="SaveGradiantBtn"
                    //type="primary"
                    name="Reject With Reason"
                    htmlType="Reject With Reason"
                    label="Reject With Reason"
                    //handleRejectWithReason={handleRejectWithReason}
                    // loading={btnLoading}
                    onClick={showRejectReason ? handleSubmitRejectReason : null}
                  />

                  <ButtonField
                    label="PR Approval"
                    type="primary"
                    onClick={handleSubmit}
                    loading={btnLoading}
                    className="SaveGradiantBtn"
                    // className="GradiantBtn SendBtn"
                  />
                </div>
              </div>
            </div>
          </section>
        </Spin>
      </div>
    </>
  );
};
export default PRApprovalButton;
